// src/services/transactionService.ts
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../lib/firebase';

export interface InstitutionStats {
  totalIncome: number;
  totalExpenses: number;
  balance: number;
  currentMonthIncome: number;
  currentMonthExpenses: number;
  transactionCount: number;
}

export const calculateInstitutionStats = async (institutionId: string): Promise<InstitutionStats> => {
  if (!institutionId) {
    return {
      totalIncome: 0,
      totalExpenses: 0,
      balance: 0,
      currentMonthIncome: 0,
      currentMonthExpenses: 0,
      transactionCount: 0,
    };
  }

  try {
    const transactionsRef = collection(db, 'transactions');
    const q = query(transactionsRef, where('institutionId', '==', institutionId));
    const querySnapshot = await getDocs(q);

    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    let totalIncome = 0;
    let totalExpenses = 0;
    let currentMonthIncome = 0;
    let currentMonthExpenses = 0;
    let transactionCount = 0;

    querySnapshot.forEach((doc) => {
      const transaction = doc.data();
      const amount = transaction.amount || 0;
      transactionCount++;

      if (transaction.type === 'income' && transaction.status !== 'rejected') {
        totalIncome += amount;

        if (transaction.createdAt) {
          const transactionDate = transaction.createdAt.toDate 
            ? transaction.createdAt.toDate() 
            : new Date(transaction.createdAt);
          
          if (transactionDate.getMonth() === currentMonth && 
              transactionDate.getFullYear() === currentYear) {
            currentMonthIncome += amount;
          }
        }
      } else if (transaction.type === 'expense' && transaction.status !== 'rejected') {
        totalExpenses += amount;

        if (transaction.createdAt) {
          const transactionDate = transaction.createdAt.toDate 
            ? transaction.createdAt.toDate() 
            : new Date(transaction.createdAt);
          
          if (transactionDate.getMonth() === currentMonth && 
              transactionDate.getFullYear() === currentYear) {
            currentMonthExpenses += amount;
          }
        }
      }
    });

    return {
      totalIncome,
      totalExpenses,
      balance: totalIncome - totalExpenses,
      currentMonthIncome,
      currentMonthExpenses,
      transactionCount,
    };
  } catch (error) {
    console.error('Error calculating institution stats:', error);
    throw error;
  }
};